import { computed, reactive, ref } from '@nuxtjs/composition-api'
import mobileVoiceSubscriptionOnlyFlowHandler from '~/composable/checkout/handler/mobileVoiceSubscriptionOnlyFlowHandler';
import { STEP_TYPE } from '~/constants/StepType';
import useCustomerInfo from '~/composable/checkout/useCustomerInfo';
import { SECRET_NUMBER_TYPE, INITIATE_NP, CUSTOMER_SUBSCRIPTION_TYPE } from '~/constants/CheckoutFlow';
import useConfirmationInfo from '~/composable/checkout/useConfirmationInfo';
import usePaymentInfo from '~/composable/checkout/usePaymentInfo';
// checkout flow context for Mobile Voice
export default (appContext) => {
  // panel 2 - subscription
  const subscription = (() => {
    const menu = ref(null)

    const newNumber = reactive({
      mobileNumber: '',
      valid: false,
      numberSelected: {},
      secretNumber: {
        selected: false,
        radioGroup: SECRET_NUMBER_TYPE.SECRET_NONE
      },
      simTypeRadioGroup: null // default selected radio button
    })

    const moveNumber = reactive({
      formValid: false,
      valid: false,
      numberValid: false,
      mobileNumber: '',
      simcardNumber: '',
      secretNumber: {
        selected: false,
        radioGroup: SECRET_NUMBER_TYPE.SECRET_NONE
      },
      simTypeRadioGroup: null, // default selected radio button
      registerSimLater: false,
      initiateNpASAP: INITIATE_NP.WHEN_BINDING_EXPIRES, // default selected radio button
      cpsCode: '',
      accepted: false
    })

    const changeSubscription = reactive({
      valid: true,
      number: '',
      isUpgrade: null,
      subscriptions: null,
      prepaidAccountId: null,
      serviceAccountId: null,
      bundleName: ''
    })

    const changeSubscriptionOnMitTelmore = reactive({
      valid: true
    })

    return {
      moveNumber,
      newNumber,
      changeSubscription,
      changeSubscriptionOnMitTelmore,
      menu
    }
  })()

  // Debug helper: log only when selection changes (avoid computed log spam)
  const lastLoggedNewNumberSelectionId = ref(null)

  const numberInfo = computed(() => {
    if (subscription?.menu?.value === CUSTOMER_SUBSCRIPTION_TYPE.NEW_NUMBER) {
      // @ts-ignore
      const mobileNumber = subscription.newNumber.numberSelected.phoneNumber
      const mobileNumberId = subscription.newNumber.numberSelected.id

      if (mobileNumberId && lastLoggedNewNumberSelectionId.value !== mobileNumberId) {
        lastLoggedNewNumberSelectionId.value = mobileNumberId
      }
      return {
        np: false,
        mobileNumber,
        mobileNumberId,
        simcardType: subscription.newNumber.simTypeRadioGroup,
        secretNumber: subscription.newNumber.secretNumber.selected,
        secretInfoType: subscription.newNumber.secretNumber.radioGroup
      }
    } else if (subscription?.menu?.value === CUSTOMER_SUBSCRIPTION_TYPE.MOVE_NUMBER) {
      return {
        np: true,
        mobileNumber: subscription.moveNumber.mobileNumber,
        simcardNumber: subscription.moveNumber.simcardNumber,
        simcardType: subscription.moveNumber.simTypeRadioGroup,
        secretNumber: subscription.moveNumber.secretNumber.selected,
        secretInfoType: subscription.moveNumber.secretNumber.radioGroup,
        cpsCode: subscription.moveNumber.cpsCode,
        initiateNpASAP: subscription.moveNumber.initiateNpASAP
      }
    }
  })
  const panels = [
    {
      stepType: STEP_TYPE.SUBSCRIPTION_TYPE,
      heading: 'Opsætning af abonnement',
      component: 'tlm-checkout-sim-combined-step',
      componentDone: 'tlm-checkout-sim-combined-step-done',
      // validationComponent: 'tlm-checkout-step-validators-user-in-quarantine-validation',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.CUSTOMER_INFO,
      heading: 'Kundeforhold',
      component: 'tlm-checkout-customer-info',
      componentDone: 'tlm-checkout-customer-type-done',
      contextName: 'customerRelation'
    },
    {
      stepType: STEP_TYPE.CUSTOMER_INFO_CONFIRMATION,
      heading: 'Kundeoplysninger',
      component: 'tlm-checkout-sim-customer-confirmation-type',
      componentDone: 'tlm-checkout-customer-info-done',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.PAYMENT,
      heading: 'Betaling',
      component: 'payment-container',
      hasNextButton: false
    }
  ]
  let flowHandler = null;
  flowHandler = mobileVoiceSubscriptionOnlyFlowHandler();
  const { payment } = usePaymentInfo()
  const { confirmation } = useConfirmationInfo()
  return {
    numberInfo,
    flowHandler,
    panels,
    subscription,
    customerInfo: useCustomerInfo(appContext),
    confirmation,
    payment
  }
}
